//  import { Map as ImmutableMap } from 'immutable';
import { resourceStoreTypes, resourceUpserters } from 'app-components/flux/core';
import { combineActions, handleActions } from 'redux-actions';

import * as actions from './transferHistoryActions';

const transferHistoryReducer = handleActions(
  {
    [actions.getTransferHistory]: (state) => state.merge({ isLoading: true }),
    [actions.getTransferHistorySuccess]: (state, action) => resourceUpserters.upsertResources(state, action.payload),
    [actions.getTransferHistoryFailure]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),

    [combineActions(
      // optimistic update
      //  actions.cancelTransferAction,
      // reconcile the optimistic update
      actions.cancelTransferActionSuccess,
    )]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),

    [actions.cancelTransferActionFailure]: (state, { payload: error, asyncDispatch }) => {
      asyncDispatch(actions.getTransferHistory());
      return resourceUpserters.resetResources(state, error);
    },
  },
  resourceStoreTypes.mkQcsSyncResourceStore(),
);

export const TRANSFER_HISTORY_REDUCER_KEY = 'transferHistoryStore';
export default transferHistoryReducer;
